import { CbButton } from 'ui/components/Buttons/CbButton';
import styles from './../ContentStyles.module.css';
export interface CompletedCardProps {
  unlockedCampaigns?: [{
    id: number;
    name: string;
  }];
}
export const CompletedCard = ({
  unlockedCampaigns
}: CompletedCardProps) => {
  return <div className={styles.cardContent} data-sentry-component="CompletedCard" data-sentry-source-file="CompletedCard.tsx">
      <h1>Congrats!</h1>
      <p style={{
      marginBottom: '4rem'
    }}>
        You’re ready to win in your next game!
      </p>
      <CbButton href="/games" size="md" aria-label="Return to Game Center" margin="0 auto" data-sentry-element="CbButton" data-sentry-source-file="CompletedCard.tsx">
        Return to Game Center
      </CbButton>
      <ul>
        {unlockedCampaigns?.map(campaign => <a key={campaign.id} href={`/games/${campaign.id}`}>
            {campaign.name}
          </a>)}
      </ul>
    </div>;
};